import { rutinInfos } from '../../_Common/Const/RutinInfo';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../../_Common/Components/ListRutin/ListRutin';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';
const KRRutiner = {
  rtnManuellInbetalning: {
    component: withAddStartedRoutine(rutinInfos.rtnManuellInbetalning)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'NAMN', caption: 'Namn' },
          { attributeDef: 'KUNDTYP', caption: 'Typ av kund' },
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Nummer' },
          { attributeDef: 'Kundkategori.BENAMNING', caption: 'Kundkategori' },
          {
            attributeDef: 'ReskontraSaldoAkt_Erb',
            caption: 'Resk.saldo inkl erbj',
          },
        ],
        notImplemented('ManuellInbetalning DetailComp')
      )
    ),
  },
  rtnBetalningsfiler: {
    component: getStandardRutin(
      rutinInfos.rtnBetalningsfiler,
      'KRBetalningsfil'
    ),
  },
  // Kanske inte ska med (if AvenySession.AgressoAktiv)
  rtnAterrappAgresso: {
    component: getStandardRutin(
      rutinInfos.rtnAterrappAgresso,
      'KRAterrapKundfakt'
    ),
  },
  rtnUtbetalningtillgodohavande: {
    component: withAddStartedRoutine(rutinInfos.rtnUtbetalningtillgodohavande)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'OrgPers.Namn', caption: 'Namn' },
          { attributeDef: 'KUNDTYP', caption: 'Typ av kund' },
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Nummer' },
          { attributeDef: 'Kundkategori.BENAMNING', caption: 'Kundkategori' },
          { attributeDef: 'TillgodoPerDatum2', caption: 'Tillgodohavande' },
          {
            attributeDef: 'ReskontraSaldoAkt_Erb',
            caption: 'Resk.saldo inkl erbj',
          },
        ],
        notImplemented('UtbetalningAvTillgodohavande DetailComp')
      )
    ),
  },
  rtnKreditering: {
    component: withAddStartedRoutine(rutinInfos.rtnKreditering)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'NAMN', caption: 'Namn' },
          { attributeDef: 'KUNDTYP', caption: 'Typ av kund' },
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Nummer' },
          { attributeDef: 'Kundkategori.BENAMNING', caption: 'Kundkategori' },
          {
            attributeDef: 'ReskontraSaldoAkt_Erb',
            caption: 'Resk.saldo inkl erbj',
          },
        ],
        notImplemented('Kreditering DetailComp')
      )
    ),
  },
  rtnUtbetalningKreditfaktura: {
    component: withAddStartedRoutine(rutinInfos.rtnUtbetalningKreditfaktura)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'NAMN', caption: 'Namn' },
          { attributeDef: 'KUNDTYP', caption: 'Typ av kund' },
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Nummer' },
          { attributeDef: 'Kundkategori.BENAMNING', caption: 'Kundkategori' },
          {
            attributeDef: 'ReskontraSaldoAkt_Erb',
            caption: 'Resk.saldo inkl erbj',
          },
        ],
        notImplemented('UtbetalningAvKreditfaktura DetailComp')
      )
    ), // EDFManuellInbetalning
  },
  rtnKundfakturaanalys: {
    component: getStandardRutin(
      rutinInfos.rtnKundfakturaanalys,
      'Fakturabetalning'
    ),
  },
  rtnKundfakturahandelser: {
    component: getStandardRutin(
      rutinInfos.rtnKundfakturahandelser,
      'EKFakturahandelse'
    ),
  },
  rtnBeraknaTillgodoranta: {
    component: withAddStartedRoutine(rutinInfos.rtnBeraknaTillgodoranta)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Nummer' },
          { attributeDef: 'Namn', caption: '' },
          { attributeDef: 'AdressRad', caption: 'Adress' },
          { attributeDef: 'Kundkategori.BENAMNING', caption: 'Kundkategori' },
        ],
        notImplemented('BeraknaTillgodoranta DetailComp')
      )
    ),
  },
  rtnKravutskrift: {
    component: getStandardRutin(rutinInfos.rtnKravutskrift, 'KRFaktura'),
  },
  rtnKravomgang: {
    component: getStandardRutin(rutinInfos.rtnKravomgang, 'KRKravOmgang'),
  },
  rtnAutogirobet: {
    component: getStandardRutin(rutinInfos.rtnAutogirobet, 'KRBetalningsorder'),
  },
  rtnLicenser: {
    component: getStandardRutin(rutinInfos.rtnLicenser, 'KRLicenser'),
  },
};

export default KRRutiner;
